import React, { useContext, useEffect, useState, useRef } from 'react'
import { ContextoRespuesta } from './EncuestaRespond';
import UtilsBufer from '../Tools/UtilsBufer';
const server = process.env.REACT_APP_SERVER;

function PreguntaWeb(props) {
  const { respuestas, setRespuestas, encuesta, respPregunta, setCondicion, usuario, pregunta } = useContext(ContextoRespuesta);
  const { item, soloVer } = props;
  const [idRespuesta, setIdRespuesta] = useState(0);
  const [idOpcion, setIdOpcion] = useState();
  const [descripcion, setDescripcion] = useState('');
  const [recupero, setRecupero] = useState(false);
  const [optionResp,setOptionResp] = useState([]);
  const guardarRespuesta = (valor) => {
    var aux = respuestas.filter((item) => item.ID_PREGUNTA == respPregunta.ID_PREGUNTA);
    if (aux.length !== 0) {
      if (respPregunta.TIPO === 'R'|| respPregunta.TIPO === 'F'||respPregunta.TIPO==='H') {
        var auxR = respuestas.filter((item) => item.ID_PREGUNTA !== respPregunta.ID_PREGUNTA);
        if (valor !== '') {
          aux[0].DESCRIPCION = valor;
          setRespuestas([...auxR, aux[0]]);
        } else {
          setRespuestas(auxR);
        }
      } else if (respPregunta.TIPO === 'S') {
        var auxR = respuestas.filter((item) => item.ID_PREGUNTA !== respPregunta.ID_PREGUNTA);
        aux[0].ID_OPCION = valor.ID_OPCION;
        setCondicion(valor.CONDICION);
        setRespuestas([...auxR, aux[0]]);
      } else if (respPregunta.TIPO === 'M') {
        var aux2 = aux.filter((item) => item.ID_OPCION === valor.ID_OPCION)
        var auxR = respuestas.filter((item) => item.ID_OPCION !== valor.ID_OPCION);
        if (aux2.length !== 0) {
          setRespuestas([...auxR])
        } else {
          setRespuestas([...respuestas, {
            "ID_RESPUESTA": idRespuesta,
            "ID_PREGUNTA": respPregunta.ID_PREGUNTA,
            "ID_ENCUESTA": respPregunta.ID_ENCUESTA,
            "ID_EMPLEADO": usuario.ID_EMPLEADO,
            "ID_OPCION": valor.ID_OPCION,
            "DESCRIPCION": null
          }])
        }
      } else if(respPregunta.TIPO ==='O'){
        var aux2 = aux.filter((item)=>item.ID_OPCION === valor.ID_OPCION)
        var auxR = respuestas.filter((item) => item.ID_OPCION !== valor.ID_OPCION);
        if (aux2.length !== 0) {
          aux2[0].DESCRIPCION=valor.DESCRIPCION
          setRespuestas([...auxR,...aux2])
        } else {
          setRespuestas([...respuestas, {
            "ID_RESPUESTA": idRespuesta,
            "ID_PREGUNTA": respPregunta.ID_PREGUNTA,
            "ID_ENCUESTA": respPregunta.ID_ENCUESTA,
            "ID_EMPLEADO": usuario.ID_EMPLEADO,
            "ID_OPCION": valor.ID_OPCION,
            "DESCRIPCION": valor.DESCRIPCION
          }])
        }
      }
    } else {
      if (respPregunta.TIPO === 'R' || respPregunta.TIPO === 'F'||respPregunta.TIPO==='H') {
        setRespuestas([...respuestas, {
          "ID_RESPUESTA": idRespuesta,
          "ID_PREGUNTA": respPregunta.ID_PREGUNTA,
          "ID_ENCUESTA": respPregunta.ID_ENCUESTA,
          "ID_EMPLEADO": usuario.ID_EMPLEADO,
          "ID_OPCION": 0,
          "DESCRIPCION": valor
        }])
      } else if (respPregunta.TIPO === 'S' || respPregunta.TIPO === 'M') {
        setCondicion(valor.CONDICION);
        setRespuestas([...respuestas, {
          "ID_RESPUESTA": idRespuesta,
          "ID_PREGUNTA": respPregunta.ID_PREGUNTA,
          "ID_ENCUESTA": respPregunta.ID_ENCUESTA,
          "ID_EMPLEADO": usuario.ID_EMPLEADO,
          "ID_OPCION": valor.ID_OPCION,
          "DESCRIPCION": null
        }])
      } else if(respPregunta.TIPO ==='O'){
        setCondicion("");
        setRespuestas([...respuestas, {
          "ID_RESPUESTA": idRespuesta,
          "ID_PREGUNTA": respPregunta.ID_PREGUNTA,
          "ID_ENCUESTA": respPregunta.ID_ENCUESTA,
          "ID_EMPLEADO": usuario.ID_EMPLEADO,
          "ID_OPCION": valor.ID_OPCION,
          "DESCRIPCION": valor.DESCRIPCION
        }])
      }
    }
  }
  function guardarOptionResponde(valor,opcion){
    var valorF = optionResp.filter(item=>item.ID_OPCION==opcion.ID_OPCION);
    if(valorF.length!=0){
      valorF[0].DESCRIPCION=valor
      var sinOption = optionResp.filter(item=>item.ID_OPCION!=opcion.ID_OPCION);
      setOptionResp([...sinOption,...valor])
    }else{
      setOptionResp([...optionResp,{'ID_OPCION':opcion.ID_OPCION,'DESCRIPCION':valor}])
    }
    guardarRespuesta({'ID_OPCION':opcion.ID_OPCION,'DESCRIPCION':valor})
  }
  function obtenerValor(dato){
    console.log(dato);
    var aux = respuestas.filter(item=>item.ID_OPCION==dato.ID_OPCION && item.ID_PREGUNTA==dato.ID_PREGUNTA)
    if(aux.length!=0){
      return UtilsBufer.getText(aux[0].DESCRIPCION)
    }else{
      return ''
    }
  }
  function guardarDescripcion(valor) {
    setDescripcion(valor);
    guardarRespuesta(valor);
  }
  function guardarFecha(valor) {
    setDescripcion(valor);
    guardarRespuesta(valor);
  }
  const validarSeleccion = (dato) => {
    if (dato.ID_OPCION == idOpcion) {
      return true;
    } else {
      return false;
    }
  }
  function validarSeleccionMultiple(dato) {
    var aux = respuestas.filter((item) => item.ID_PREGUNTA == respPregunta.ID_PREGUNTA && dato.ID_OPCION == item.ID_OPCION);
    if (aux.length !== 0) {
      return true;
    } else {
      return false;
    }
  }
  useEffect(() => {
    if (item.ID_PREGUNTA === respPregunta.ID_PREGUNTA) {
      var aux = respuestas.filter((item) => item.ID_PREGUNTA == respPregunta.ID_PREGUNTA);
      setCondicion('');
      if (aux.length !== 0) {
        setIdOpcion(aux[0].ID_OPCION);
        setIdRespuesta(aux[0].ID_RESPUESTA);
        if (typeof aux[0].DESCRIPCION == "string") {
          setDescripcion(aux[0].DESCRIPCION);
        } else {
          setDescripcion(UtilsBufer.getText(aux[0].DESCRIPCION));
        }
        setRecupero(true);
      } else {
        setRecupero(true);
      }
    } else {
      setRecupero(false);
    }
  }, [pregunta])
  return (
    <div className='card-body'>
      {item.TIPO === 'R' &&
        <input type="text" id='respuesta'
          className="form-control form-control-sm"
          placeholder="Responde aqui ..."
          disabled={soloVer}
          value={descripcion}
          onChange={(e) => guardarDescripcion(e.target.value.toUpperCase())}
        />
      }
      {item.TIPO === 'S' &&
        <div className=''>
          {recupero === true && item.OPCIONES.map((item, index) => {
            return (
              <div className="form-check py-2 fs-2" key={index}>
                <input className="form-check-input " type="radio" onClick={() => guardarRespuesta(item)}
                  name="flexRadioDefault" id={`${item.NOMBRE}`} disabled={soloVer}
                  defaultChecked={validarSeleccion(item)} />
                {item.NOMBRE &&
                  <div className='position-relative' style={{ width: "50px" }}>
                    <img src={`${server}/imagenes/${item.NOMBRE}`} className="img-fluid">
                    </img>
                  </div>}
                <label className="form-check-label" >
                  {UtilsBufer.getText(item.DESCRIPCION)}
                </label>
              </div>
            )
          })}
        </div>}
      {item.TIPO === 'M' &&
        <div className=''>
          {recupero === true && item.OPCIONES.map((item, index) => {
            return (
              <div className="form-check py-2 fs-2" key={index}>
                <input className="form-check-input" type="checkbox" onClick={() => guardarRespuesta(item)}
                  name="flexRadioDefault" id={`${item.NOMBRE}`} disabled={soloVer}
                  defaultChecked={validarSeleccionMultiple(item)} />
                {item.NOMBRE &&
                  <div className='position-relative' style={{ width: "75px" }}>
                    <img src={`${server}/imagenes/${item.NOMBRE}`} className="img-fluid">
                    </img>
                  </div>}
                <label className="form-check-label " >
                  {UtilsBufer.getText(item.DESCRIPCION)}
                </label>
              </div>
            )
          })}
        </div>}
      {item.TIPO === 'O' &&
        <div className=''>
          {item.OPCIONES.map((opti, index) => {
            return (
              <div className='row row-cols g-1'>
                {opti.NOMBRE &&
                  <div className='col' style={{ width: "70px" }}>
                    <div className='position-relative' style={{ width: "70px" }}>
                      <img src={`${server}/imagenes/${opti.NOMBRE}`} className="img-fluid">
                      </img>
                    </div>
                  </div>}
                <div className='col'>
                  <div className="input-group mb-1 input-group-sm" key={index}>
                    <label className="input-group-text">{UtilsBufer.getText(opti.DESCRIPCION)}</label>
                    <input className="form-control" type="text" placeholder='Responde aqui' disabled={soloVer} 
                    onChange={(e)=>guardarOptionResponde(e.target.value,opti)} value={obtenerValor(opti)}/>
                  </div>
                </div>
              </div>
            )
          })}
        </div>}
      {item.TIPO === 'F' &&
        <div className='container-fluid fs-2'>
          <span>Fecha: </span>
          <input type="date" className="form-control form-control-sm" style={{ width: '200px' }} disabled={soloVer}
            onChange={(e) => guardarFecha(e.target.value)} value={descripcion} />
        </div>}
      {item.TIPO === 'H' &&
        <div className='container-fluid fs-2'>
          <span>Hora: </span>
          <input type="time" className="form-control form-control-sm" style={{ width: '200px' }} disabled={soloVer} 
            onChange={(e) => guardarFecha(e.target.value)} value={descripcion}
          />
        </div>}
    </div>
  )
}

export default PreguntaWeb
